import React, { HTMLProps } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Switch } from 'react-router-dom'
import Alerts from 'out-game/root/Alerts'
import AppBar from 'out-game/root/AppBar'
import Footer from 'out-game/root/Footer'
import PopupOnMain from 'out-game/root/PopupOnMain'
import { Panel as NotificationPanel } from 'out-game/root/Notifications'
import Search from 'out-game/root/Search'
import MakeDeal from 'out-game/root/MakeDeal'
import ChatButton from 'out-game/root/ChatButton'
import { RouteWithSubRoutes } from 'out-game/router/RootRouter'
import { RoutesListType } from 'out-game/router/routerConfig'
import { lsManager } from '../utils/localstorage'

import './style.scss'
import { isServer } from 'out-game/constants'

type ShellProps = HTMLProps<HTMLDivElement> & {
  readonly routes: RoutesListType<{}>[]
}

const Shell: React.FC<ShellProps> = (props) => {
  const { routes } = props

  const reqStateAll = useSelector((state) => state.requests)
  const { pathname } = useLocation()
  const isPageMain = pathname === '/'

  const isFooterVisible =
    reqStateAll.games === 'success' ||
    reqStateAll.games === 'failure' ||
    !isPageMain

  const isRussian = !isServer && lsManager.language === 'ru'
  const isPopupOnMain = isRussian && isPageMain

  return (
    <>
      <MakeDeal />
      <ChatButton />
      <AppBar />
      <NotificationPanel />
      <Search />
      <main>
        <Switch>
          {routes?.map((route, index) => (
            <RouteWithSubRoutes key={index} {...route} />
          ))}
        </Switch>
      </main>
      {isFooterVisible && <Footer />}
      <Alerts />
      {isPopupOnMain && <PopupOnMain />}
    </>
  )
}

export default Shell
